import { ExportPatientExportTypeEnum, PatientControllerApi } from "../services";
import { getConfigObject, useMutationWithLoading } from "../utils/utils";

/**
 *
 * @author Shrinivas Mandare
 */
interface Params {
  exportType: ExportPatientExportTypeEnum;
  xTENANTID?: string;
  requestBody: Array<string>;
}

export const useExportPatient = () =>
  useMutationWithLoading(async (params: Params) =>
    new PatientControllerApi(getConfigObject()).exportPatient(
      params.exportType,
      params.requestBody,
      params.xTENANTID,
      {
        responseType: "arraybuffer",
      }
    )
  );
